import { AsyncPipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { Observable } from 'rxjs';

import { SummaryItem } from '../../models';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrl: './summary.component.scss',
  imports: [AsyncPipe],
})
export class SummaryComponent {
  readonly model$ = input<Observable<any>>();
  public readonly summaryItems = input<(model: any) => SummaryItem[]>();
}
